import { Button } from "@deligoo/ui"
import { memo, useCallback, useRef } from "react"
import { useTranslation } from "react-i18next"
import { Popup } from "react-leaflet"
import { shallowEqual, useDispatch } from "react-redux"

import { useAppSelector } from "@/App"
import { selectClientById } from "@/store/clients"
import { setAboutPanel } from "@/store/ui"
import { Client } from "@/types"
import { signInPOS } from "@/utils"

import cls from "./Popup.module.scss"

export const ClientPopup = memo(({ clientId }: { clientId: Client["id"] }) => {
  const client = useAppSelector(selectClientById(clientId), shallowEqual)

  const popupRef = useRef<Popup | null>(null)

  const dispatch = useDispatch()

  const showAboutOrder = useCallback(() => {
    popupRef.current?.leafletElement["_map"].closePopup()
    dispatch(setAboutPanel({ type: "client", id: clientId }))
  }, [dispatch, clientId])

  const { t } = useTranslation()

  if (!client) return null

  return (
    <Popup
      ref={popupRef}
      closeOnEscapeKey={false} // Overwritten with custom event
      closeButton={false}
      minWidth={360}
      maxWidth={360}
    >
      <div className={cls.content}>
        <div className={cls.title}>{client.name}</div>
        <div className={cls.subtitle}>{client.address}</div>
        <div className="d-flex justify-between">
          <Button color="primary" variation="outlined" iconProps={{ name: "restaurants" }} onClick={showAboutOrder}>
            {t("details")}
          </Button>

          <Button color="primary" iconProps={{ name: "business-client" }} raised onClick={() => signInPOS(clientId)}>
            {t("log_in_to_panel")}
          </Button>
        </div>
      </div>
    </Popup>
  )
})
